/* eslint-disable import/prefer-default-export */

const SIGN_IN_MODAL_SELECTOR = ".js-sign-in-modal";

const $getSignInModal = () => document.querySelector(SIGN_IN_MODAL_SELECTOR);

// Module-scoped storage for 2FA data — prefer getTwoFactorData() over window globals
let twoFactorData = {};

export const SignInModalUtils = {
  closeModal() {
    const $modalElement = $getSignInModal();
    if ($modalElement && $?.fn?.modal) {
      $($modalElement).modal("hide");
    }
  },

  createSignInButton(text = "Sign In") {
    return `<button
      type="button"
      data-testid="sign-in-toggle-button-from-error"
      data-sign-up-text="${text}"
      class="underline underline-offset-2 js-sign-in-modal-toggle"
    >
      ${text}
    </button>`;
  },

  replaceLoginLinkWithButton(errorMessage) {
    if (!errorMessage || typeof errorMessage !== "string") {
      return this.createSignInButton();
    }

    const signInLinkPattern = /<a[^>]*href=["']\/login["'][^>]*>([^<]+)<\/a>/gi;
    const replacedMessage = errorMessage.replace(signInLinkPattern, (_, linkText) => {
      const buttonText = linkText || "Sign In";
      return this.createSignInButton(buttonText);
    });

    return replacedMessage;
  },

  setGlobal2FAData(data, formAction) {
    twoFactorData = {
      authToken: data.authToken,
      rawPhoneNumber: data.rawPhoneNumber,
      phoneNumber: data.phoneNumber,
      email: data.email,
      smsEnabled: data.smsEnabled,
      emailEnabled: data.emailEnabled,
      redirectUrl: formAction || undefined
    };

    // TODO(MN-4415-phase2): SECURITY — Remove window globals below once ERB consumers
    // are migrated to ES module imports. The following ERB inline scripts still read
    // directly from window:
    //   - _verification_modal.erb (window.twoFactorAuthToken, window.rawPhoneNumber)
    //   - new.html.erb (window.twoFactorAuthToken, window.rawPhoneNumber)
    //   - _admin_two_factor_modal.html.erb (window.twoFactorAuthToken)
    // Until those are migrated, removing these globals breaks 2FA login flow.
    // Prefer SignInModalUtils.getTwoFactorData() for new code.
    Object.assign(window, {
      twoFactorAuthToken: data.authToken,
      rawPhoneNumber: data.rawPhoneNumber,
      twoFactorRedactedPhone: data.phoneNumber,
      twoFactorRedactedEmail: data.email,
      smsEnabled: data.smsEnabled,
      emailEnabled: data.emailEnabled,
      twoFactorRedirectUrl: formAction || undefined
    });
  },

  /**
   * Returns a shallow copy of the module-scoped 2FA data.
   *
   * Field mapping from legacy window globals (for phase 2 migration):
   *   - `authToken`      ← `window.twoFactorAuthToken`
   *   - `rawPhoneNumber` ← `window.rawPhoneNumber`
   *   - `phoneNumber`    ← `window.twoFactorRedactedPhone`
   *   - `email`          ← `window.twoFactorRedactedEmail`
   *   - `smsEnabled`     ← `window.smsEnabled`
   *   - `emailEnabled`   ← `window.emailEnabled`
   *   - `redirectUrl`    ← `window.twoFactorRedirectUrl`
   *
   * @returns {Record<string, unknown>} Copy of stored 2FA data
   */
  getTwoFactorData() {
    return { ...twoFactorData };
  },

  /**
   * Clears the module-scoped 2FA data and window globals to reduce the token
   * exposure window. Call after successful 2FA verification.
   */
  clearTwoFactorData() {
    twoFactorData = {};

    // Also clear window globals set by setGlobal2FAData for ERB backward compat
    delete window.twoFactorAuthToken;
    delete window.rawPhoneNumber;
    delete window.twoFactorRedactedPhone;
    delete window.twoFactorRedactedEmail;
    delete window.smsEnabled;
    delete window.emailEnabled;
    delete window.twoFactorRedirectUrl;
  },

  handleTwoFactorAuth(data, formElement, modalElement) {
    this.setGlobal2FAData(data, formElement.getAttribute("data-redirect-url"));
    $(modalElement).modal("hide");
    window.initTwoFactorModal();
  }
};
